import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=6da1d103&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=6da1d103&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1d103",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da1d103')) {
      api.createRecord('6da1d103', component.options)
    } else {
      api.reload('6da1d103', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=6da1d103&scoped=true", function () {
      api.rerender('6da1d103', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/DataTable.vue"
export default component.exports